export enum DataOrigin {
  NONE = 'NONE',
  FILES = 'FILES',
  REPOSITORY = 'REPOSITORY',
  ANONYMOUS = 'ANONYMOUS',
}
